import { Pipe, PipeTransform } from '@angular/core';
import { TextHelper } from '../helpers/text.helper';

@Pipe({
  name: 'textEllipsis',
  standalone: false,
})
export class TextEllipsisPipe implements PipeTransform {
  transform(str: string, length: number, shouldShorten = true): string {
    if (!shouldShorten) {
      return str;
    }
    return TextHelper.textEllipsis(str, length);
  }
}
